import {
  Component,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {FormModel, FormState} from '../../common/components/form/models';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {DatePipe} from '@angular/common';
import {FormulaireService} from '../../common/services/formulaire/formulaire.service';
import {roles} from '../../common/enum/roles';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {SubSink} from '@Common/core/utils/subsink';
import {ActivatedRoute, Router} from '@angular/router';
import {StateValidationComponent} from '../../common/components/form/form-states/state-validation/state-validation.component';
import {MatDialog} from '@angular/material/dialog';
import {finalize} from 'rxjs/operators';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {StateValidationModel} from '../../common/components/form/form-states/state-validation/state-validation.model';
import {UrlService} from '../../common/services/url/url.service';

@Component({
  selector: 'app-formulaires-archived',
  templateUrl: './formulaires-archived.component.html',
  styleUrls: ['./formulaires-archived.component.scss']
})
export class FormulairesArchivedComponent implements OnInit, OnDestroy, OnChanges {
  dsFormulaires: MatDataSourceGeneric<FormModel> = new MatDataSourceGeneric<FormModel>();
  extraParams: Map<string, string> = new Map<string, string>();
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  loading = false;
  columns: ColumnDataTable[] = [
    {
      columnDef: 'nom', header: 'Formulaire', display: (row: FormModel) => row.nom,
      tooltip: (row: FormModel) => row.nom,
      sort: true, flex: 30
    },

    {
      columnDef: 'dt_created', header: 'Créé le', display: (element: FormModel) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${element.dt_created}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      tooltip: (element) => {
        return element.dt_created;
      },
      sort: true
    },

    {
      columnDef: 'dt_updated', header: 'Modifié le', display: (element: FormModel) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${element.dt_updated}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      tooltip: (element) => {
        return element.dt_updated;
      },
      sort: true
    },
  ];
  actions: ActionDataTable[] = [
    {
      label: 'responses', tooltip: 'Réponses pour ce formulaire', icon: 'receipt',
      tooltipfct: (row: FormModel) => `Réponses pour ce formulaire : ${row.responses_send}`,
      hidden: (row: FormModel) => row.responses_send === 0,
      click: (row: FormModel) => this.getResponsesForm(row),
      iconcolor: 'accent',
    },
    {
      label: 'reactivate', tooltip: 'Réactiver ce formulaire', icon: 'unarchive',
      click: (row: FormModel) => this._reactivateForm(row),
      iconcolor: 'warn',
    },
  ];
  subSink = new SubSink();
  @Input() adminView = false;
  connecte: Individu;

  constructor(@Inject(LOCALE_ID) private locale: string,
              private router: Router, private route: ActivatedRoute,
              private dialog: MatDialog,
              private pubSubSvc: PubSubService,
              private snackSvc: SnackBarToastyService,
              private urlSvc: UrlService,
              private individuService: IndividuService,
              private formulaireSvc: FormulaireService) {
    this.dsFormulaires.daoService = this.formulaireSvc;
  }
  ngOnInit(): void {
    this.subSink.sink = this.individuService.individu$.subscribe(individu => {
      this.connecte = individu;
      const isAdmin = this.individuService.hasRole(individu, roles.admin);
      if (!isAdmin || !this.adminView) {
        this.extraParams.set('by_gestionnaire', individu.uid);
      }
      this.extraParams.set('state', FormState.archived.toString());
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const cur = changes.adminView.currentValue;
    const old = changes.adminView.previousValue;
    if (cur !== old && !changes.adminView.firstChange) {
      if (cur) {
        this.extraParams.delete('by_gestionnaire');
      } else {
        this.extraParams.set('by_gestionnaire', this.connecte.uid);
      }
      this.dataTable.reload();
    }
  }

  private _publishForm(form: FormModel) {
    this.pubSubSvc.publish('loading', true);
    form.state = FormState.published;
    this.subSink.sink = this.formulaireSvc
      .patch(form, 'uuid')
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_form: FormModel) => {
        this.dataTable.reload();
        this.snackSvc.toasty(
          'Etat du formulaire',
          `Le formulaire est maintenant en ligne, retrouvez le dans l'onglet "Formulaires"`,
          typeToast.success);
      });
  }
  private _reactivateForm(row: FormModel) {
      const dialogRef = this.dialog.open(StateValidationComponent, { data: row });
      dialogRef.disableClose = true;
      dialogRef.updatePosition({top: '50px'});
      dialogRef.afterClosed().subscribe((result: StateValidationModel) => {
        if (result.validate) {
          this._publishForm(row);
        } else {
          const _url = result.form.url_obj && result.form.url_obj.length > 0 ? result.form.url_obj[0] : null;
          if (_url) {
            this.subSink.sink = this.urlSvc.delete(_url).subscribe();
            this.dataTable.reload();
          }
        }
      });
  }
  getResponsesForm(formulaire: FormModel) {
    this.router.navigate(['responses', formulaire.uuid], {relativeTo: this.route.parent});
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
